import template from './UserDimensionView.html';
import * as styles from './userDimension.module.scss';
import { EventEmitter } from 'modules/shared/EventEmitter';
import { ODataOperator, ODataFunction } from 'types/OData';
import { UserFeatures } from 'modules/application/detail/users/UserFeatures';
/**
 * Component to encapsulate users dimension rules and fields.
 * Dependencies: dimensionFilter.component
 */
class UserDimensionController {
    static $inject = ['$element', '$timeout'];
    constructor($element, $timeout) {
        'ngInject';
        this.$element = $element;
        this.$timeout = $timeout;
        this.disableType = false;
        this.styles = styles;
        this.checkFeatures();
    }
    async checkFeatures() {
        this.isUsingStartsWithOnContactsSearch = await UserFeatures.isUsingStartsWithOnContactsSearch();
    }
    $onRemoveDimension() {
        if (this.onRemoveDimension) {
            this.onRemoveDimension(EventEmitter({ dimension: this.data }));
        }
    }
    handleOnAddItem(startWithStartsWith = false) {
        if (this.onAddItem) {
            this.onAddItem(EventEmitter({
                init: {
                    condition: startWithStartsWith
                        ? (this.isUsingStartsWithOnContactsSearch
                            ? ODataFunction.StartsWith
                            : ODataFunction.Contains)
                        : ODataOperator.Equals,
                },
            }));
        }
    }
    handleOnRemoveItem(index = undefined) {
        if (this.onRemoveItem) {
            this.onRemoveItem(EventEmitter({ index }));
        }
        this.handleOnChanges({ changes: this.data });
    }
    handleOnChanges({ changes }) {
        if (this.onChanges) {
            this.onChanges(EventEmitter({ changes }));
        }
    }
}
UserDimensionController.$inject = ['$element', '$timeout'];
export const UserDimensionComponent = {
    template,
    controller: UserDimensionController,
    controllerAs: '$ctrl',
    bindings: {
        data: '<',
        onAddItem: '&?',
        onRemoveItem: '&?',
        onRemoveDimension: '&?',
        onChanges: '&?',
        disableType: '<?',
        conditionDisabled: '<?',
    },
};
